import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { PaginateBase } from '@/components/ui/Navigation/PaginateBase';
const contentStyle = 'flex';
const buttonStyle = clsx('flex items-center justify-center', 'w-[40px] h-[40px]', 'text-base text-13', 'hover:cursor-pointer');
const buttonWrapStyle = clsx('border border-solid border-gray-300', 'bg-white hover:bg-gray-75', 'rounded-md');
const buttonDisabledStyle = 'hover:cursor-default';
const buttonWrapDisabledStyle = clsx('border border-solid border-gray-300', 
// HACK: buttonWrapStyle と競合してしまうため、!important で上書き
'!bg-gray-300 !hover:bg-gray-300', 'pointer-events-none');
export const Paginate = (props) => {
    const { className = '', forcePage, hrefBuilder, marginPagesDisplayed, nextLabel, onClick, onPageChange, pageCount, pageLabelBuilder, pageRangeDisplayed, previousLabel, } = props;
    const classNames = {
        active: clsx(buttonWrapDisabledStyle, '!block'),
        activeLink: buttonDisabledStyle,
        break: clsx(buttonWrapStyle, 'mr-8', 'hidden md:block'),
        breakLink: buttonStyle,
        container: clsx(contentStyle, className),
        disabled: buttonWrapDisabledStyle,
        next: buttonWrapStyle,
        nextLink: buttonStyle,
        page: clsx(buttonWrapStyle, 'mr-8', 'hidden md:block'),
        pageLink: buttonStyle,
        previous: clsx(buttonWrapStyle, 'mr-8'),
        previousLink: buttonStyle,
    };
    return (_jsx(PaginateBase, { classNames: classNames, forcePage: forcePage, hrefBuilder: hrefBuilder, marginPagesDisplayed: marginPagesDisplayed, nextLabel: nextLabel, onClick: onClick, onPageChange: onPageChange, pageCount: pageCount, pageLabelBuilder: pageLabelBuilder, pageRangeDisplayed: pageRangeDisplayed, previousLabel: previousLabel }));
};
